import DefaultLayout from './DefaultLayout';
import Customers from './Customers';

export { 
  DefaultLayout,
  Customers
 };



// WEBPACK FOOTER //
// ./src/containers/index.js